<template>
	<div class="dis_set">
		<div class="tc_nav">
			<span class="tc_navx"></span>
		</div>
		<header>
			<h1>
				<router-link :to="'/video/dilie/'+item.b_type_id" class='huiqu' v-for="(item,index) in book_li" :key="index">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">专辑详情</p>
			</h1>
		</header>
		<div class="dis_cont">
			<!-- head -->
			<!-- 专辑 -->
			<div class="dis_head" v-for="item in book_li">
				<img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+item.b_pic" class="dish_img">
				<div class="dish_cnth" >
					<p class="dish_p1">{{item.b_bookname}}</p>
					<p class="dish_p2" v-if="item.b_author != '' && item.b_author != null">作者：<span>{{item.b_author}}</span></p>
                    <p class="dish_p3" v-if="item.b_readuser != '' && item.b_readuser != null">朗读：<span>{{item.b_readuser}}</span></p>
                    <p class="dish_p4" v-if="item.b_genre != '' && item.b_genre!= null">体载：<span>{{item.b_genre}}</span></p>
                    <p class="dish_p5" v-if="item.b_people != '' && item.b_people != null">适合人群：<span>{{item.b_people}}</span></p>
					<p class="dish_p6">
						<v-icon name="clone" class="dis_clone"></v-icon>&nbsp;<span>{{item.b_partnum}}</span>&nbsp;&nbsp;&nbsp;
						<v-icon name="clock" class="dis_clock"></v-icon>&nbsp;<span>{{item.b_timelength}}</span>&nbsp;&nbsp;&nbsp;
						<v-icon name="tv" class="dis_bell"></v-icon>&nbsp;<span>{{item.b_playnum}}</span>&nbsp;&nbsp;&nbsp;
					</p>
				</div>
			</div>
			<!-- but -->
			<div class="dis_heada" v-for="item in book_li">
				<div class="dis_hada" v-on:click="heart()"><v-icon name="heart" class="dis_heart" id="ddd_zz"></v-icon><span id="ddd_sz">{{item.b_collectnum}}</span></div>
				<div class="dis_xxx"></div>
				<div class="dis_hadb" v-on:click="clone()"><v-icon name="thumbs-up" class="dis_up" id="ddd_zx"></v-icon><span id="ddd_sdz">{{item.b_praisenum}}</span></div>
				<div class="dis_hadc" id="b_price">{{item.moeny}}{{item.b_price}}</div>
				<div class="dis_hadd">
					<!-- <router-link :to="'/discover/pay/'+item.b_id"> -->
					<button class="dis_haddbut" v-on:click="setvip(item.b_price)">购买专辑</button>
					<!-- </router-link> -->
				</div>
			</div>
			<!-- cont -->
			<!-- but -->
			<div class="dis_cnt">
				<button 
				class="cnt_butx" id="cnt_butd">信息描述</button><div class="dis_xx"></div><button 
				class="cnt_butxa">书评书籍</button><div class="dis_xx"></div><button 
				class="cnt_butxb">读者评价</button>
			</div>
			<!-- contc -->
			<div class="dis_cntc" id="dis_cntcp" v-for="item in book_li" v-html="item.b_describe">
				<p>
				{{item.b_describe}}
				</p>
			
			</div>
			<div class="dis_cntc" id="dis_cntcpx" v-for="item in book_li" v-html="item.b_abstract">
				<p>
					{{item.b_abstract}}
				</p>
				
			</div>
			<div id="dis_cntpl">
				<!-- 1 -->
								<!-- featured -->
				<div class="cntpl_x1" v-for="item in book_pl">
					<img :src="item.co_pic" class="x1_ximg">
					<p class="x1_xp1 shouye_dianxxx">{{item.co_usersname}}</p>
					<p class="x1_xp2">{{item.co_add_time}}</p>
					<p class="x1_xxp">{{item.co_content}}</p>
					<img :src="item.pic1" v-if="item.pic1 != '' && item.pic1!= null" class="ordinary" @click='pic1(item.pic1)'>
					<img :src="item.pic2" v-if="item.pic2 != '' && item.pic2!= null" class="ordinary" @click='pic1(item.pic2)'>
					<img :src="item.pic3" v-if="item.pic3 != '' && item.pic3!= null" class="ordinary" @click='pic1(item.pic3)'>
					<button class="playeco" @click="playecofe(item.localId)"></button>
					<video :src="item.video1" class="ordinaryb" v-if="item.video1 != '' && item.video1!= null" controls="controls" height="150" width="100%"></video>
				</div>
				<!-- ordinary -->
				<div class="cntpl_x2" v-for="item in tolerate">
					<img :src="item.co_pic" class="x1_ximg">
					<p class="x1_xp1 shouye_dianxxx">{{item.co_usersname}}</p>
					<p class="x1_xp2">{{item.co_add_time}}</p>
					<p class="x1_xxp">{{item.co_content}}</p>
					<img :src="item.pic1" v-if="item.pic1 != '' && item.pic1!= null" class="ordinary" @click='pic1(item.pic1)'>
					<img :src="item.pic2" v-if="item.pic2 != '' && item.pic2!= null" class="ordinary" @click='pic1(item.pic2)'>
					<img :src="item.pic3" v-if="item.pic3 != '' && item.pic3!= null" class="ordinary" @click='pic1(item.pic3)'>
					<button class="playeco" @click="playecofe(item.localId)"></button>
					<video :src="item.video1" class="ordinaryb" v-if="item.video1 != '' && item.video1!= null" controls="controls" height="150" width="100%"></video>
				</div>
				<!-- but -->
				<div class="cntpl_xx1">
					<button class="cxx1_but" v-on:click="loadmore()">加载更多</button>
					<button class="cxx2_but" v-on:click="evaluate()">我要评价</button>
				</div>
				<!-- ed -->
			</div>
			<!-- 悬浮选择评论 -->
			<div class="choose">
				<div class="chooses">
					<button class="text comments" v-on:click="text()">图文评论</button>
					<button class="voice comments" v-on:click="voice()">语音评论</button>
					<button class="video comments" v-on:click="video()">视频评论</button>
				</div>
			</div>
			<!-- 视频录制 -->
			<div id="videox">
				<v-icon name="window-close" class="dclose"></v-icon>
				<div class="viax"></div>
				<form id="videoxc" method="post" action="http://ts.winwulian.com/portal/All/getshipin" enctype="multipart/form-data" target="xcac">
				<div class="menux">
					<input type="file" id='viex' accept="video/*" capture='camcorder' name="video">
					<input type="text" name="openid" class="openid" style="display: none;">
					<input type="text" name="book_id" class="book_id" style="display: none;">
					<div class="point"></div>
				</div>
				<button class="vido_but" name="Submit">发表评论</button>
				</form>
				<iframe id="id_iframe" name="xcac" style="display: none;"></iframe>
			</div>
			<!-- 悬浮发表图文评论 -->
			<div id="pppp_xxxxx">
				<div class="pj_xxz">
					<div class="xxz_div1">
						<p class="xxz_ppp">评论专辑</p><!-- <button class="">语言评论</button> -->
						<div class="xxz_ppp1"><v-icon name="window-close" class="dis_close"></v-icon></div>
					</div>
					<!-- <div class="cha"></div> -->
					<textarea placeholder="评论审核之后才会显示" maxlength="100" class="xxz_textx"></textarea>
					<form id="imgasc" method="post" action="http://ts.winwulian.com/portal/All/getpicpl" enctype="multipart/form-data" target="nm_iframe">
						<div class="cha"></div>
						<div class="menu">
							<input type="file" name="pic" class="form-control" id="images">
							<input type="file" name="pics" class="form-control" id="image">
							<input type="file" name="picss" class="form-control" id="imag">
							<input type="text" name="openid" class="openid" style="display: none;">
							<input type="text" name="content" class="content" style="display: none;">
							<input type="text" name="book_id" class="book_id" style="display: none;">
							<span class="cross"></span>
						</div>
						<button class="xxz_butpp" id="fileSubmit" name="Submit">发表评论</button>
					</form>
					<iframe id="id_iframe" name="nm_iframe" style="display: none;"></iframe>
				</div>
			</div>
			<!-- 悬浮发表语音评论 -->
			<div class="voices">
				<img src="../../img/comments.png" class="vimgs">
				<div class="voiceis">
					<button class="comments" id="recording">长按录音</button>
					<button class="comments" id="cancelco">取消</button>
				</div>
			</div>
			<!-- end -->
			<div class="dis_endx">
				<div class="ed_va">
					<div class="dis_x"></div>
					<p class="ed_vp">章节列表</p>
				</div>
				<div class="ed_vcnt" >
                
					<div class="ed_vcntx" v-for="item in book_sp" @click="ff(item.book_id,item.bp_id,item.bp_price)">
						<v-icon name="file" class="dis_filex"></v-icon>
						<p>{{item.bp_title}}</p>
						<div class="ed_vcnt1">
							<v-icon name="tv" class="dis_bell"></v-icon>
							<span>{{item.bp_play_num}}</span>&nbsp;&nbsp;&nbsp;
							<v-icon name="clock" class="dis_clock"></v-icon>
							<span>{{item.bp_timelength}}</span>&nbsp;&nbsp;&nbsp;		
						</div>
						<p class="ed_vcnt2">{{item.money}}{{item.bp_price}}</p>	
					</div>
                   
					</div>
					<!-- 没有了 -->
					<div class="ed_vcntx text_axc">
						<p>没有更多了...</p>
					</div>
				</div>
			</div>
			<!--  -->
		</div>
	</div>
</template>
<script>
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
	inject:['reload'],
	 data(){
          return {
              params: '',
              book_li:[],
              book_zj:[],
              book_pl:[],
              status_zs:[],
              moneypay:[],
              j:[],
              d:[],
              tolerate:[],
              jssdkpage:[],
              vx:[],
          }
      },
created(){
	var param = this.$route.params.id;
	this.params = param
},
methods:{
//
   	loadmore:function(){
   		$('.cntpl_x2').fadeIn()
		$('.cxx1_but').text("没有更多了")
   	},
//
  //  	comment:function(){
  //  		var openid = localStorage.getItem("openid");
  //  		var content = $('.xxz_textx').val()
		// if(content == '' || content == null){
		// 	$('.xxz_textx').css('border','red solid 1px')
		// }else{
		//     this.$http.get(CURL+'/portal/All/getaddpl?content='+content
		//     	+'&openid='+openid+'&book_id='+this.book_li[0].b_id
		//     	);
		//     $('.tc_navx').text('评价成功，等待审核！')
		// 	$('.tc_nav').fadeIn()
		// 	$('#pppp_xxxxx').fadeOut()
		// 	setTimeout(function(){
		// 		$('.tc_nav').fadeOut()
		// 		$('.xxz_textx').css('border','#eee solid 1px')
		// 		$('.xxz_textx').val('')
		// 	},2000)
		// }
  //  	},
//
		pic1 (e) {
			var html = ''
			var oAll = $('.dis_set')
			html =	'<div style="background-color: rgba(0,0,0,0.39);position:fixed;top:0;left:0;text-align:center;width:100%;height:100%;" class="oAllimg">'
					+'<img src="'+e+'" style="width:75%;height:auto;margin-top:50%;" />'
					+'</div>'
			oAll.append(html)
			$('.oAllimg').click(function(){
				$('.oAllimg').hide()
			})
		},
//
   	evaluate:function(){
   		$('.choose').fadeIn(500);
       		$('.choose').click(function(){
       			$('.choose').fadeOut(500)
       		})
   	},
//图文评论
   	text () {
   		$('.choose').fadeOut()
   		$('#pppp_xxxxx').fadeIn(500)
   	},
//语音评论
   	voice () {
   		$('.choose').fadeOut()
   		$('.voices').fadeIn(500)
   	},
//视频评论
   	video () {
   		$('.choose').fadeOut()
   		$('#videox').fadeIn(500)
   	},
//
   	setvip:function(b_price){
   		if(this.moneypay == 1){
   			$('.tc_navx').text('此书免费')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
   		}else{
            var sp = 1
// 			location.href = '/discover/pay/'+[this.book_li[0].b_id,'',b_price,sp];
   			this.$router.push({path: '/discover/pay/'+[this.book_li[0].b_id,'',b_price,sp]});
   		}
   	},
// 收藏  	
   	heart:function(){
   		var openid=localStorage.getItem("openid");
         var successCallback =  (response) => {
         	var i=this.book_li[0].b_collectnum
            this.j++
            var c = this.j % 2
            if(c != 0){
            	this.book_li[0].b_collectnum = i+1
            	$('#ddd_zz').css('color','#00a8d9')
            }else{
            	this.book_li[0].b_collectnum =i-1
            	$('#ddd_zz').css('color','#777')
            }
          }
          var errorCallback =  (response) => {
              console.log('服务器请求出错了')
          }
          // 向后台传id 根据id接收数据
          this.$http.get(CURL+'/portal/All/getshoucan?book_id='+this.$route.params.id+'&openid='+openid,{
            data:{}
          }).then(successCallback,errorCallback);	
   	},
//
    ff:function(book_id,bp_id,moeny){
       var openid=localStorage.getItem("openid");
        var successCallback =  (response) => {
            console.log(response)
            var sp = 1
            if(response.status == 2 || response.status == 1 || moeny == '免费'){
//              location.href = '/video/playm/'+[book_id,bp_id]
                this.$router.push({path: '/video/playm/'+[book_id,bp_id]});
            }else{
//              location.href = '/discover/pay/'+[book_id,bp_id,moeny,sp];
                this.$router.push({path: '/discover/pay/'+[book_id,bp_id,moeny,sp]});
            }

          }
        var errorCallback =  (response) => {
              console.log('服务器请求出错了')
          }
        this.$http.get(CURL+'/portal/All/getzjorder?book_id='+book_id+'&bp_id='+bp_id+'&openid='+openid,{
            data:{}
          }).then(successCallback,errorCallback);
        
    },
// 点赞
   	clone:function(){
   		var openid=localStorage.getItem("openid");
         var successCallback =  (response) => {
         	var i=this.book_li[0].b_praisenum
            this.d++
            var c = this.d % 2
            if(c != 0){
            	this.book_li[0].b_praisenum = i+1
            	$('#ddd_zx').css('color','#00a8d9')
            }else{
            	this.book_li[0].b_praisenum =i-1
            	$('#ddd_zx').css('color','#777')
            }
          }
          var errorCallback =  (response) => {
              console.log('服务器请求出错了')
          }
          // 向后台传id 根据id接收数据
          this.$http.get(CURL+'/portal/All/getdianzan?book_id='+this.$route.params.id+'&openid='+openid,{
            data:{}
          }).then(successCallback,errorCallback);
   	},
//
    getAjax:function () {
        var openid=localStorage.getItem("openid");
     	var successCallback =  (response) => {
        console.log('服务器请求成功了')
        if(response.status.dianzan == 0){
     		setTimeout(function(){
     			$('#ddd_zx').css('color','#00a8d9')
     		},200)
     	}else{
     		setTimeout(function(){
     			$('#ddd_zx').css('color','#333')
     		},200)
     	}
     	if(response.status.shoucang == 0){
     		setTimeout(function(){
     			$('#ddd_zz').css('color','#00a8d9')
     		},200)
     	}else{
     		setTimeout(function(){
     			$('#ddd_zz').css('color','#333')
     		},200)
     	}
        if(response.booklist[0].b_is_free == '2'){
        	response.booklist[0].b_price = '免费'
        	this.moneypay=1
        }else{
        	response.booklist[0]['moeny'] = '￥'
        }
        // 精选
        for(var i=0;i<response.commentlist_jx.length;i++){
        	if(response.commentlist_jx[i].co_sign == 1){
        		if(response.commentlist_jx[i].pl_pic != null){
        			response.commentlist_jx[i]['pic1']=CURL+'/uploads/plphoto/'+response.commentlist_jx[i].pl_pic
        		}
        		if(response.commentlist_jx[i].pl_pic_two != null){
        			response.commentlist_jx[i]['pic2']=CURL+'/uploads/plphoto/'+response.commentlist_jx[i].pl_pic_two
        		}
        		if(response.commentlist_jx[i].pl_pic_san != null){
        			response.commentlist_jx[i]['pic3']=CURL+'/uploads/plphoto/'+response.commentlist_jx[i].pl_pic_san
        		}	
        	}else if(response.commentlist_jx[i].co_sign == 2){
        		// response.commentlist_jx[i]['sound1']=CURL+'/'+response.commentlist_jx[i].pl_yuyin
        	}else if(response.commentlist_jx[i].co_sign == 3){
        		response.commentlist_jx[i]['video1']=CURL+'/uploads/shipin/'+response.commentlist_jx[i].pl_shipin
        	}
        }
        // 普通
        for(var i=0;i<response.commentlist_mr.length;i++){
        	if(response.commentlist_mr[i].co_sign == 1){
        		if(response.commentlist_mr[i].pl_pic != null){
        			response.commentlist_mr[i]['pic1']=CURL+'/uploads/plphoto/'+response.commentlist_mr[i].pl_pic
        		}
        		if(response.commentlist_mr[i].pl_pic_two != null){
        			response.commentlist_mr[i]['pic2']=CURL+'/uploads/plphoto/'+response.commentlist_mr[i].pl_pic_two
        		}
        		if(response.commentlist_mr[i].pl_pic_san != null){
        			response.commentlist_mr[i]['pic3']=CURL+'/uploads/plphoto/'+response.commentlist_mr[i].pl_pic_san
        		}	
        	}else if(response.commentlist_mr[i].co_sign == 2){
        		// response.commentlist_mr[i]['sound1']=CURL+'/'+response.commentlist_mr[i].pl_yuyin
        	}else if(response.commentlist_mr[i].co_sign == 3){
        		response.commentlist_mr[i]['video1']=CURL+'/uploads/shipin/'+response.commentlist_mr[i].pl_shipin
        	}
        }

        if(response){
        	this.tolerate=response.commentlist_mr //普通评价
        	this.book_li = response.booklist
        	this.book_sp = response.bookpartlist 
        	this.book_pl = response.commentlist_jx //精选评价
        }
        for(var i=0;i<this.book_sp.length;i++){
        	if(this.book_sp[i].bp_is_free == '2'){
                // console.log(this.book_zj)
        		this.book_sp[i]['bp_price'] = '免费'
        	}else{
        		this.book_sp[i]['moeny'] = '￥'
                // console.log(this.book_sp)
        	};
        }
      }
      var errorCallback =  (response) => {
          console.log('服务器请求出错了')
      }
      // 向后台传id 根据id接收数据
      this.$http.get(CURL+'/portal/All/getxq?id='+this.$route.params.id+'&openid='+openid,{
      	data:{}
      }).then(successCallback,errorCallback);
    },
//
	getjssdk:function () {
	  var openid=localStorage.getItem("openid");
	  var successCallback =  (response) => {
	 	var signPackage=response.data;
		  wx.config({
		    debug: false,
		    appId: signPackage.appId,
		    timestamp:  signPackage.timestamp,
		    nonceStr:  signPackage.nonceStr,
		    signature:  signPackage.signature,
		    jsApiList: [
		      // 所有要调用的 API 都要加到这个列表中
		     'startRecord',
		     'stopRecord',
		     'onVoiceRecordEnd',
		     'playVoice',
		     'pauseVoice',
		     'stopVoice',
		     'onVoicePlayEnd',
		     'uploadVoice',
		    ]
		  });
	  }
	  var errorCallback =  (response) => {
	      console.log('error')
	  }
	  // 向后台传id 根据id接收数据
	  this.$http.get(CURL+'/user/weixin/jssdk?id=video/disv/'+this.$route.params.id+'&openid='+openid,{
	  	data:{}
	  }).then(successCallback,errorCallback);
	},
    //播放录音
	// 精选
	playecofe (e) {
		wx.playVoice({
			localId: e // 需要播放的音频的本地ID，由stopRecord接口获得
		});
	},
	// 普通
	playecoor (e) {
		wx.playVoice({
			localId: e // 需要播放的音频的本地ID，由stopRecord接口获得
		});
	}
},
  mounted(){
  	var openid=localStorage.getItem("openid");
  	$('.openid').val(openid)
  	$('.book_id').val(this.params)
  	var soundid=this.$route.params.id
	this.getAjax();
	this.getjssdk();
	//点赞

	// $('#ddd_zx').click(function(){
	// 	$('#ddd_zx').css('color','#00a8d9')
	// });
	$('.dis_close').click(function(){
		$('#pppp_xxxxx').fadeOut(500)
		$('.xxz_textx').css('border','#eee solid 1px')
		$('.xxz_textx').val('')
	});
	$('.dclose').click(function(){
		$('#videox').fadeOut()
	});
	// tab
	$('.cnt_butx').click(function(){
		$('#dis_cntcp').fadeIn(500)
		$('#dis_cntcpx').hide()
		$('#dis_cntpl').hide()
		$('.cnt_butx').css('border-bottom','#00a8d9 solid 2px')
		$('.cnt_butx').css('color','#00a8d9')
		$('.cnt_butxa').css('border-bottom','none')
		$('.cnt_butxa').css('color','#777')
		$('.cnt_butxb').css('border-bottom','none')
		$('.cnt_butxb').css('color','#777')
	});
	$('.cnt_butxa').click(function(){
		$('#dis_cntcp').hide()
		$('#dis_cntcpx').fadeIn(500)
		$('#dis_cntpl').hide()
		$('.cnt_butxa').css('border-bottom','#00a8d9 solid 2px')
		$('.cnt_butxa').css('color','#00a8d9')
		$('.cnt_butx').css('border-bottom','none')
		$('.cnt_butx').css('color','#777')
		$('.cnt_butxb').css('border-bottom','none')
		$('.cnt_butxb').css('color','#777')
	});
	$('.cnt_butxb').click(function(){
		$('#dis_cntcp').hide()
		$('#dis_cntcpx').hide()
		$('#dis_cntpl').fadeIn(500)
		$('.cnt_butxb').css('border-bottom','#00a8d9 solid 2px')
		$('.cnt_butxb').css('color','#00a8d9')
		$('.cnt_butx').css('border-bottom','none')
		$('.cnt_butx').css('color','#777')
		$('.cnt_butxa').css('border-bottom','none')
		$('.cnt_butxa').css('color','#777')
	})
	/*
	   * 注意：
	   * 1. 所有的JS接口只能在公众号绑定的域名下调用，公众号开发者需要先登录微信公众平台进入“公众号设置”的“功能设置”里填写“JS接口安全域名”。
	   * 2. 如果发现在 Android 不能分享自定义内容，请到官网下载最新的包覆盖安装，Android 自定义分享接口需升级至 6.0.2.58 版本及以上。
	   * 3. 常见问题及完整 JS-SDK 文档地址：http://mp.weixin.qq.com/wiki/7/aaa137b55fb2e0456bf8dd9148dd613f.html
	   *
	   * 开发中遇到问题详见文档“附录5-常见错误及解决办法”解决，如仍未能解决可通过以下渠道反馈：
	   * 邮箱地址：weixin-open@qq.com
	   * 邮件主题：【微信JS-SDK反馈】具体问题
	   * 邮件内容说明：用简明的语言描述问题所在，并交代清楚遇到该问题的场景，可附上截屏图片，微信团队会尽快处理你的反馈。
	   */
	   
	  wx.ready(function () {
	    //在这里调用 API
	    //wx.startRecord();
		  //按下开始录音
		$("#recording").on({
		  	// 开始
			touchstart:function(){
				$('.vimgs').show()
				wx.startRecord({
			        success: function(){
			            localStorage.rainAllowRecord = 'true';
			        },
			        cancel: function () {
			            alert('用户拒绝授权录音');
			        }
		       	});
			},
			// 结束
			touchend:function(){
				$('#recording').text('重新录制')
				$('.vimgs').hide()
				wx.stopRecord({
			        success: function (res) {
			          var localId = res.localId;
			          //上传录音
			          wx.uploadVoice({
						localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
						isShowProgressTips: 1, // 默认为1，显示进度提示
						success: function (res) {
						var serverId = res.serverId; // 返回音频的服务器端ID
						sound(serverId,localId)
						//把录音在微信服务器上的id（res.serverId）发送到自己的服务器供下载。
							
						}
					  });
			        },
			        fail: function (res) {
			          console.log(JSON.stringify(res));
			        }
			    });
			},
		})
      });
	  wx.error(function(res){
	  	console.log(res)
	    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
	  });
//上传录音
	function sound(serverId,localId){
        $.ajax({
            url:CURL+'/user/weixin/upload',
            type:'get',
            dataType:'json',
            data:{
				localId:localId,
                serverId:serverId,
                openid:openid,
				book_id:soundid
            },
            success:function(msg){
				if(msg.status == 200){
					$('.tc_navx').text('评价成功，等待审核！')
					$('.tc_nav').fadeIn() 
					setTimeout(function(){
						$('.tc_nav').fadeOut()
					},2000)
				}else{
					$('.tc_navx').text('error')
					$('.tc_nav').fadeIn() 
					setTimeout(function(){
						$('.tc_nav').fadeOut()
					},2000)
				}
			}
        });
	}
//播放录音
	// function playrecor(localId){
	// 	$('#playeco').click(function(){
	// 		wx.playVoice({
	// 			localId: localId // 需要播放的音频的本地ID，由stopRecord接口获得
	// 		});
	// 	})	
	// }
//取消录音
	$('#cancelco').click(function(){
		$('.voices').fadeOut()
	})
//图片预览
    function yuLan(img) {
        var file = img.files[0];
        window.FileReader
        var fr = new FileReader();
        fr.onloadend = function(e) {
            document.getElementById("img").src = e.target.result;
        };
        fr.readAsDataURL(file);
    }
    var html = ''
   	var cha=$('.cha')
   	var viax=$('.viax')
   	var i=0
   	$('#image').hide()
   	$('#imag').hide()
//第一张
    $('#images').change(function () {
	    var file = $(this)[0].files[0];
	    //通过FileReader读取选中图片
	    var reader = new FileReader();
	    reader.readAsDataURL(file);
	    reader.onload = function () {
	        //result中存放了选中的文件的二进制数据
	    	html=	'<img src="'+this.result+'" id="ssr" style="height:75px;margin: 0 5px 0 5px;" />'
			cha.append(html)
			$('#images').hide()
			$('#image').show()
	    }
	});
//第二张
    $('#image').change(function () {
	    var file = $(this)[0].files[0];
	    //通过FileReader读取选中图片
	    var reader = new FileReader();
	    reader.readAsDataURL(file);
	    reader.onload = function () {
	        //result中存放了选中的文件的二进制数据
	    	html=	'<img src="'+this.result+'" id="ssr" style="height:75px;margin: 0 5px 0 5px;" />'
			cha.append(html)
			$('#image').hide()
			$('#imag').show()
	    }
	});
//第三张
    $('#imag').change(function () {
	    var file = $(this)[0].files[0];
	    //通过FileReader读取选中图片
	    var reader = new FileReader();
	    reader.readAsDataURL(file);
	    reader.onload = function () {
	        //result中存放了选中的文件的二进制数据
	    	html=	'<img src="'+this.result+'" id="ssr" style="height:75px;margin: 0 5px 0 5px;" />'
			cha.append(html)
			$('.menu').hide()
	    }
	});
// 提交表单验证
	var inputa = $("#images");
	var inputb = $("#image");
	var inputc = $("#imag");
    $("#imgasc").submit(function () {
        var first = $(".xxz_textx").val();
        $('.content').val(first);
        var last = $("#images").get(0).files[0];
		if (first) {
        	$('.tc_navx').text('评价成功，等待审核！')
			$('.tc_nav').fadeIn()
			$('#pppp_xxxxx').fadeOut()
			$('.xxz_textx').val('')
			cha.empty()
			$('.menu').show()
			$('#images').show()
			$('#image').hide()
   			$('#imag').hide()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
				clerk()
			},2000)			
            return true;
        }else{
        	$('.tc_navx').text('请输入内容')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
			return false;
        }
    })
    function clerk(){
		inputa.val("");
		inputb.val("");
		inputc.val("");
    }
//视频判断
	var Hightx=document.body.clientHeight
	var Widthx=document.body.clientWidth
	var vhight=Math.floor(Hightx-(Hightx/2))
    $('#viex').change(function () {
	    var file = $(this)[0].files[0];
	    var url = URL.createObjectURL(file);
	    this.video_url= url;
	    html=	'<video id="video" src="'+this.video_url+'" preload="auto" autoplay="autoplay" height="'+vhight+'" width="'+Widthx+'"></video>'
	    +'<p style="color:#FFFFFF;">部分格式不支持预览！</p>'
		viax.append(html)
		$('.vido_but').show()
		$('.menux').hide()
	});
	$("#videoxc").submit(function () {
		var file = $('#viex')[0].files[0];
		if(file){
			$('.tc_navx').text('评价成功，等待审核！')
			$('#videox').fadeOut()
			$('.tc_nav').fadeIn()
			$('.vido_but').hide()
			viax.empty()
			$('.menux').show()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
				$('#viex').val("");
			},2000)
        	return true;
		}
	})
  },
  
};

</script>
<style lang="scss" scoped>
.playeco{
	height: 27px;
	width: 80px;
	margin-bottom: 10px;
	border-radius: 2px;
	background:url(../../img/sound.png);
	background-size: 100% 100%;
	background-repeat: no-repeat;
}
.ordinary{
	height: 100px;
	margin: 0 15px 15px 0;
}
.vido_but{
	margin-top: 50px;
    width: 80%;
    padding: 8px 0 8px 0;
    background-color: #00a8d9;
    color: #FFFFFF;
    border-radius: 5px;
    margin-left: 10%;
	display: none;
}
#videox{
	display: none;
	height: 100%;
	position: fixed;
	width: 100%;
	background-color: rgba(0,0,0,0.39);
}
.dclose{
	position: fixed;
	top: 6%;
	right: 3%;
}
.point{
	position: relative;
	top: -63px;
	left: 0;
	width: 55px;
	height: 55px;
	border-radius: 50%;
	background: #00a8d9;
	margin: 0 auto;
}
#viex{
	position: relative;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	z-index: 666;
}
/**/
#recording{
  -webkit-touch-callout:none;  /*系统默认菜单被禁用*/
  -webkit-user-select:none; /*webkit浏览器*/
  -khtml-user-select:none; /*早期浏览器*/
  -moz-user-select:none; /*火狐*/
  -ms-user-select:none;  /*IE10*/
  user-select:none;
}
.video{
	/*display: none;*/
}
#playeco{
	display: none;
}
#taped{
	background: red;
	display: none;
}
.vimgs{
	display: none;
	position: fixed;
	top: 35%;
	left: 35%;
	width: 100px;
	height: auto;
}
.voiceis{
	position: fixed;
	bottom: 3%;
	left: 0;
	width: 100%;
}
.voices{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0,0,0,0.39);
	display: none;
}
/**/
.comments{
	margin-top: 10px;
    width: 80%;
    padding: 8px 0 8px 0;
    background-color: #00a8d9;
    color: #FFFFFF;
    border-radius: 5px;
    margin-left: 10%;
}
.chooses{
	position: fixed;
	bottom: 30px;
	left: 0;
	width: 100%;
}
.choose{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: none;
	background-color: rgba(0,0,0,0.39);
}
/**/
.viax{
	text-align: center;
	float: left;
	width: 100%;
	overflow: hidden;
	margin-top: 15%;
}
.cha{
	float: left;
	margin: 10px 3% 10px 3%;
	overflow: hidden;
}
.cross{
	position: relative;
	bottom: 53px;
	left: 20px;
	width: 33px;
	height: 33px;
	background:url(../../img/add.png);
	background-size:100% 100%;
	background-repeat: no-repeat;
	display: block;
	z-index: 0;
}
.menu{
	float: left;
	margin: 10px 3% 10px 3%;
	width: 75px;
	height: 75px;
	background-color: #cccccc;
}
.menux{
	position: fixed;
	left: 40%;
	bottom: 3%;
	width: 75px;
	height: 75px;
	border: #00a8d9 solid 2px;
	border-radius: 50%;
}
#images,#image,#imag{
	position: relative;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	z-index: 666;
}
/**/
.tc_navx{
	background-color: #00a8d9;
	border-radius: 5px;
	padding: 10px 20px 10px 20px;
}
.tc_nav{
	display: none;
	position: fixed;
	margin-left: 20%;
	text-align: center;
	width: 60%;
	color: #ffffff;
	font-size: 15px;
	bottom: 70%;
	z-index: 99999;
}
/**/
#pppp_xxxxx{
	display: none;
	height: 100%;
	position: fixed;
	width: 100%;
	background-color: rgba(0,0,0,0.39);
}
.xxz_butpp{
	width: 94%;
	margin: 0 3% 15px 3%;
	padding: 10px 0 10px 0;
	border-radius: 5px;
	background-color: #00a8d9;
	color: #FFFFFF;
	font-weight: 600;
}
.xxz_textx::placeholder{
	color: #777;
}
.xxz_textx{
	width: 94%;
	height: 80px;
	margin: 10px 3% 10px 3%;
	padding-top: 10px;
	padding-left: 15px;
	border: #eee solid 1px;
}
.dis_close{
	height: 17px;
	width: 18px;
	color: #FFFFFF;
	background-color: #000;
}
.xxz_ppp1{
	text-align: right;
	width: 30%;
	float: right;
	margin-right: 10px;
	margin-bottom: 10px;
}
.xxz_ppp{
	font-weight: 600;
	float: left;
	width: 30%;
	margin-left: 10px;
	margin-bottom: 10px;
}
.xxz_div1{
	float: left;
	padding-top: 10px;
	width: 100%;
	border-bottom: #eee solid 2px;
}
.pj_xxz{
	background-color: #FFFFFF;
	position: fixed;
	width: 100%;
	bottom: 0;
}
/**/
.cntpl_x2{
	display: none;
	margin-top: 15px;
	width: 100%;
	float: left;
	border-bottom: #eee solid 1px;
}
.cxx2_but{
	margin-top: 10px;
	width: 80%;
	padding: 8px 0 8px 0;
	background-color: #00a8d9;
	color: #FFFFFF;
	border-radius: 5px;
}
.cxx1_but{
	padding: 8px 20px 8px 20px;
	background-color: #eee;
	color: #777;
	border-radius: 5px;
}
.cntpl_xx1{
	margin-top: 10px;
	float: left;
	width: 100%;
	text-align: center;
}
.x1_xxp{
	float: left;
	width: 100%;
	margin: 8px 0 8px 1px;
	color: #777;
}
.x1_xp2{
	text-align: right;
	height: 25px;
	line-height: 25px;
	width: 46%;
	float: right;
	overflow: hidden;
	color: #777;
	padding-right: 10px;
}
.x1_xp1{
	color: #777;
	padding-left: 10px;
	height: 25px;
	line-height: 25px;
	width: 35%;
	float: left;
	overflow: hidden;
}
.x1_ximg{
	float: left;
	width: 25px;
	height: 25px;
	border-radius: 50%;
}
.cntpl_x1{
	margin-top: 15px;
	width: 100%;
	float: left;
	border-bottom: #eee solid 1px;
}
#dis_cntpl{
	margin-top: 10px;
	padding: 0 15px 0 15px;
	float: left;
	width: 100%;
	display: none;
}
#dis_cntcpx{
	display: none;
}
/*contc*/
.ed_vcnt2{
	float: right;
	color: #00a8d9;
	margin-right: 15px;
}
.ed_vcnt1{
	width: 60%;
	float: left;
}
.dis_filex{
	margin-left: 15px;
	float: left;
	height: 100%;
	width: 21px;
	color: #00a8d9;
	margin-right: 15px;
}
.ed_vcntx{
	margin-top: 15px;
	float: left;
	width: 100%;
	border-bottom: #ccc solid 2px;
	padding-bottom: 10px;
}
.text_axc{
	text-align: center;
	border-bottom: none;
}
.dis_endx{
	margin-top: 20px;
}
.dis_endx,.ed_vcnt{
	float: left;
	width: 100%;
}
.ed_vp{
	float: left;
	width: 40%;
	padding-left: 15px;
}
.ed_va{
	width: 100%;
	float: left;
}
.dis_x{
	margin-top: 4px;
	float: left;
	width: 20px;
	height: 10px;
	background-color: #bad565;	
}
.dis_cntc{
	margin-top: 10px;
	padding: 0 15px 0 15px;
	float: left;
	width: 100%;
	p{
		line-height: 20px;
	}
}
/*cont*/
#cnt_butd{
	margin-left: 13%;
	border-bottom: #00a8d9 solid 2px;
	margin-right: 15px;
	color: #00a8d9;
}
.cnt_butxa{
	margin-right: 15px;
	margin-left: 15px;
}
.cnt_butxb{
	margin-left: 15px;
}
.dis_xx{
	margin-top: 4px;
	float: left;
	width: 1px;
	height: 10px;
	background-color: #777;
}
.cnt_butx,.cnt_butxa,.cnt_butxb{
	float: left;
	background-color: inherit;
	padding-bottom: 5px;
	font-weight: 500;
	text-align: center;
	width: 20%;
	color: #777;
}
.dis_cnt{
	margin-top: 15px;
	float: left;
	width: 100%;
}
/*conthead*/
.dis_xxx{
	margin-top: 9px;
	float: left;
	width: 1px;
	height: 10px;
	background-color: #777;
}
.dis_heart,.dis_up,{
	width: 10px;
	padding-top: 6px;
	margin-right: 5px;
}
.dis_hadebut{
	border: #777 solid 1px;
	padding: 5px 10px 5px 10px;
	background-color: #FFFFFF;
	border-radius: 8px;
	font-size: 12px;
	color: #777;
}
.dis_haddbut{
	padding: 5px 10px 5px 10px;
	background-color: #00a8d9;
	color: #FFFFFF;
	border-radius: 8px;
	font-size: 12px;
}
.dis_hada{
	margin-top: 2px;
	text-align: center;
	width: 14%;
	float: left;
	color: #777;
}
.dis_hadb{
	margin-top: 2px;
	text-align: center;
	width: 15%;
	float: left;
	color: #777;
}
.dis_hadc{
	margin-top: 5px;
	width: 12%;
	float: left;
	color: #00a8d9;
}
.dis_hadd,.dis_hade{
	text-align: center;
	width: 25%;
	float: left;
}
.dis_heada{
	width: 100%;
	float: left;
}
/**/
.dis_clone,.dis_clock,.dis_bell{
	width: 10px;
	padding-top: 5px;
	color: #00a8d9;
}
.dish_p1{
	font-size: 14px;
	margin-bottom: 5px;
	margin-top: 5px;
}
.dish_p2,.dish_p3,.dish_p4,.dish_p5,.dish_p6{
	color: #888;
}
.dish_cnth{
	float: left;
	width: 68%;
}
.dish_img{
	width: 23%;
	height: 118px;
	margin: 0 16px 0 10px;
	float: left;
}
.dis_head{
	width: 100%;
	float: left;
	margin-top: 15px;
}
.dis_cont{
	float: left;
	width: 100%;
	margin-top: .4rem;
}
/*head*/
header{
	position: fixed;
  	height: .4rem;
 	background:url(../../img/ss.png);
    background-size:100% 100%;
    background-repeat: no-repeat;
 	float: left;
 	width: 100%;
}
.set_1{
	text-align: center;
    float: left;
    width: 80%;
    line-height: .4rem;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
}
.set_2{
	float: left;
	margin-left: 3%;
	margin-top: 12px;
	width: 5%;
	color: #FFFFFF;
}
/*xxxx*/
.dis_set{
	width: 100%;
}
/**/
.shouye_dianxxx{
  overflow: hidden;
  white-space:nowrap;
  -webkit-text-overflow:ellipsis;
  -moz-text-overflow:ellipsis;
  -o-text-overflow:ellipsis;
  -ms-text-overflow:ellipsis;
  text-overflow:ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/video/disv.vue